export const config = {
    // TEST:'http://192.168.43.194:80/Ramesh/reactWebBackend/reactWebBackend.php?request=',
    // TEST:'http://localhost/Ramesh/reactWebBackend/reactWebBackend.php?request=',
    // TEST:'http://192.168.1.209:80/Ramesh/reactWebBackend/reactWebBackend.php?request=',
    // TEST:'http://106.195.35.192/reactWebBackend/reactWebBackend.php?request=',
    TEST:'https://www.dev.allskills.in/reactWebBackend/reactWebBackend.php?request=',

  };